import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MatDialog } from '@angular/material/dialog'; // Importaciones actualizadas
import { UsersServiceService } from 'src/app/services/users-service.service';
import { MessageBoxComponent } from 'src/app/modales/message-box/message-box.component';

@Component({
    selector: 'app-recupera-pass',
    templateUrl: './recupera-pass.component.html',
    styleUrls: ['./recupera-pass.component.scss'],
    standalone: false
})
export class RecuperaPassComponent {
  
  formulario = new FormGroup({
    correo: new FormControl("", [Validators.required, Validators.email])
  });

  constructor(
    private _users: UsersServiceService,
    public dialogRef: MatDialogRef<RecuperaPassComponent>, // Actualización aquí
    private dialog: MatDialog // Actualización aquí
  ) { 
    dialogRef.disableClose = true;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  enviar() {
    if (this.formulario.valid) {
      console.info(this.formulario.getRawValue());
      this._users.getCorreo(this.formulario.getRawValue()).subscribe(results => {
        if (results.code == 200) {
          console.log(results.datos);
          this._users.sendCorreo(results.datos.usuario).subscribe(results => {
            if (results.code == 200) {
              console.log(results);
              this.dialog.open(MessageBoxComponent, { 
                disableClose: true,
                data: {
                  title: "El mensaje se envió exitosamente",
                  text: "Revise su correo donde encontrará sus datos para iniciar sesión.",
                  icon: "done",
                  href: "/"
                }
              });
            }
          });
          this.dialog.closeAll();
        } else {
          this.dialog.open(MessageBoxComponent, { 
            disableClose: true,
            data: {
              title: "No se encontró el correo ingresado.",
              text: "Por favor, verifique su correo y vuelva a intentar.",
              icon: "error_outline",
              href: "/"
            }
          });
        }
      }, error => {
        console.info(error);
      });
    }
  }
}
